import 'flatpickr/dist/themes/material_blue.css'

import {
	FormContentSection,
	FormSectionCard,
	FormSectionTitle,
	Select,
	StyledTextArea,
} from './PasserCommande.styles'
import React, { useEffect, useRef, useState } from 'react'

import AddCourse from '../../assets/img/add_course@2x.png'
import Agrandir from '../../assets/img/agrandir@2x.png'
import CourseStep from './CourseStep'
import Reduire from '../../assets/img/reduire@2x.png'
import _ from 'lodash'
import { getDistanceBetweenTwoPlaces } from '../../api/distance'
import moment from 'moment'
import { totalDistance } from '../../utils/price'
import { useAtom } from 'jotai'
import SingleCourseStep from './SingleCourseStep'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
function InformationCourseACourse({
	unregister,
	register,
	watch,
	setValue,
	initialNumberOfCourses = 1,
	display = false,
	keepFilesAsObjects = false,
	control,
	getValues,
	errors,
	heur,
	setHeur,
	isStepOne
}) {
	const [distance, setDistance] = useAtom(totalDistance)
	const [heureVector, setHeureVector] = useState(new Map())
	const token = useSelector((state) => state.auth.token);
	const prevIsStepOne = useRef(isStepOne);
	const [numberOfCourses, setNumberOfCourses] = useState(
		initialNumberOfCourses
	)
	const [collapsedItems, setCollapsedItems] = useState([])

	const _courses = useRef([])
	_courses.current = watch('courses')

	useEffect(() => {
		setNumberOfCourses(initialNumberOfCourses)
	}, [initialNumberOfCourses])
	useEffect(() => {
			console.log('numbre',numberOfCourses)
		if(!isStepOne  ){
			console.log('numbre',numberOfCourses)
		localStorage.setItem('numberOfCourses', numberOfCourses.toString());
		}
		if(isStepOne && numberOfCourses!==1 ){
			console.log('numbre',numberOfCourses)
		localStorage.setItem('numberOfCourses', numberOfCourses.toString());
		}
		  }, [numberOfCourses]);

	  useEffect(() => {

		if(isStepOne  ){
			const storedNumberOfCourses = localStorage.getItem('numberOfCourses');
			setNumberOfCourses(parseInt(storedNumberOfCourses))
			console.log('storedNumberOfCourses',storedNumberOfCourses)
		}
		
	  }, []);
	
	const [placesVector, setPlacesVector] = useState(new Map())
	const [distanceVector, setDistanceVector] = useState(new Map())

	useEffect(() => {
		console.log("setDistanceVector",distanceVector)
		setDistance(_.sum(Array.from(distanceVector.values())))
	}, [distanceVector])
	useEffect(()=>{
      console.log("placesVector",placesVector)
	},[placesVector])
    const {t} = useTranslation()
	return (
		<FormContentSection>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
				}}
			>
				<FormSectionTitle>{t("transport_information")}</FormSectionTitle>

				<svg
					xmlns='http://www.w3.org/2000/svg'
					style={{
						width: 20,
						height: 20,
						marginTop: 10,
						marginLeft: 10,
					}}
					fill='none'
					viewBox='0 0 24 24'
					stroke='#51C7F2'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth={2}
						d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
					/>
				</svg>
			</div>

			{[...Array(parseInt(numberOfCourses || 1)).keys()].map((i) => (
				<FormSectionCard key={String(i)}>
					<div
						onClick={() =>
							setCollapsedItems(
								collapsedItems.filter((x) => x != i)
							)
						}
						style={{
							position: 'absolute',
							top: 10,
							right: 10,
							cursor: 'pointer',
							display: !collapsedItems.includes(i)
								? 'none'
								: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<span>{t("expand")}</span>

						<img
							src={Agrandir}
							style={{ height: 30, marginLeft: '0.5rem' }}
							alt=''
						/>
					</div>

					<div
						onClick={() =>
							setCollapsedItems([...collapsedItems, i])
						}
						style={{
							position: 'absolute',
							bottom: 10,
							right: 10,
							cursor: 'pointer',
							display: collapsedItems.includes(i) || numberOfCourses <= 1
								? 'none'
								: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<span>{t("collapse")}</span>
						<img
							src={Reduire}
							style={{ height: 30, marginLeft: '0.5rem' }}
							alt=''
						/>
					</div>

					{(!display && numberOfCourses-1===i)&& (
						<div
							onClick={async () => {
								_courses.current.splice(i, 1)
								setNumberOfCourses(numberOfCourses - 1)
								localStorage.setItem('numberOfCourses',parseInt(localStorage.getItem('numberOfCourses')-1) );

								setValue('courses', _courses.current)
								unregister(`courses.${i}.date_transport`)
								unregister(`courses.${i}.type`)
								unregister(`courses.${i}.adresse`)
								unregister(`courses.${i}.time`)
								unregister(`courses.${i}.notes`)

								

								placesVector.delete(`${i}-fin`);
                                setPlacesVector(new Map(placesVector));
								distanceVector.delete(`${i}-fin`)
								setDistanceVector(new Map(distanceVector));


								
							}}
							style={{
								position: 'absolute',
								bottom: collapsedItems.includes(i)
									? 'unset'
									: 10,
								top: collapsedItems.includes(i) ? 10 : 'unset',
								right: 120,
								cursor: 'pointer',
								display: i > 0 ? 'flex' : 'none',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<div
								style={{
									height: 30,
									width: 30,
								}}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									className='h-6 w-6'
									fill='none'
									viewBox='0 0 24 24'
									stroke='currentColor'
								>
									<path
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth={2}
										d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
									/>
								</svg>
							</div>
						</div>
					)}

					<div
						style={{
							display: collapsedItems.includes(i)
								? 'flex'
								: 'none',
							flexDirection: 'row',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								//marginBottom: '2.5rem',
								width: '100%',
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									width: '50%',
								}}
							>
								<span
									style={{
										marginBottom: '1rem',
										color: 'black',
										fontSize: 14,
									}}
								>
									Date et type
								</span>

								<div
									style={{
										background: 'white',
										width: '100%',
										display: 'flex',
										flex: 1,
										borderRadius: '0.5rem',
										border: 'none',
										padding: '1rem',
										fontFamily: 'Montserrat',
										color: '#858ea8',
										alignItems: 'center',
										justifyContent: 'space-around',
									}}
								>
									<span>
										{watch(
											`courses[${i}].date_transport`
										) &&
											moment(
												watch(
													`courses[${i}].date_transport`
												)
											).format('DD/MM/YYYY')}
									</span>
									<span>
										{getValues(`courses[${i}].time`) &&
											watch(`courses[${i}].time`)}
									</span>
									<span>-</span>
									<span>{watch(`courses[${i}].type`)}</span>
								</div>
							</div>

							<div
								style={{
									width: '1rem',
								}}
							/>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									width: '50%',
								}}
							>
								<span
									style={{
										marginBottom: '1rem',
										color: 'black',
										fontSize: 14,
									}}
								>
									Adresse
								</span>

								<div
									style={{
										background: 'white',
										width: '100%',
										display: 'flex',
										flex: 1,
										borderRadius: '0.5rem',
										border: 'none',
										padding: '1rem',
										fontFamily: 'Montserrat',
										color: '#858ea8',
										alignItems: 'center',
									}}
								>
									<span>
										{
											watch(`courses[${i}].adresse`)
												?.value?.description
										}
									</span>
								</div>
							</div>
						</div>
					</div>

					{
						i === 0 ? (
							<CourseStep
								collapsedItems={collapsedItems}
								keepFilesAsObjects={keepFilesAsObjects}
								i={i}
								watch={watch}
								register={register}
								errors={errors} 
								getValues={getValues}
								setValue={setValue}
								control={control}
								display={display}
								placesVector={placesVector}
								setPlacesVector={setPlacesVector}
								distanceVector={distanceVector}
								setDistanceVector={setDistanceVector}
								heureVector={heureVector}
								setHeureVector={setHeureVector}
								heur={heur}
								setHeur={setHeur}
							/>
						) : (
							<SingleCourseStep
								collapsedItems={collapsedItems}
								keepFilesAsObjects={keepFilesAsObjects}
								i={i}
								watch={watch}
								register={register}
								getValues={getValues}
								setValue={setValue}
								control={control}
								display={display}
								placesVector={placesVector}
								setPlacesVector={setPlacesVector}
								distanceVector={distanceVector}
								setDistanceVector={setDistanceVector}
								errors={errors} 
								setHeur={setHeur}
							/>
						)
					}

				</FormSectionCard>
			))}

			{!display && (
				<div
					onClick={() => setNumberOfCourses(numberOfCourses + 1)}
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-start',
						cursor: 'pointer',
						marginTop: '2rem',
					}}
				>
					<img
						style={{ height: 40, marginRight: '1rem' }}
						src={AddCourse}
						alt=''
					/>
					<span>{t("add_trip")}</span>
				</div>
			)}
		</FormContentSection>
	)
}

export default InformationCourseACourse
